import BaseProxy from './Base';

class PlayersProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('players', parameters, 'api/v1');
  }

  getPlayers(query) {
    const parameters = {};
    if (Object.prototype.hasOwnProperty.call(query, 'column')) {
      parameters.order = `${query.order === 'descending' ? '-' : ''}${query.column}`;
    } else {
      parameters.order = 'name';
    }
    if (Object.prototype.hasOwnProperty.call(query, 'filter')) {
      parameters.q = query.filter;
    }
    if (query.team_id) {
      parameters.team_id = query.team_id;
    } else {
      if (!Object.prototype.hasOwnProperty.call(query, 'page')) {
        parameters.page = 1;
      } else {
        parameters.page = query.page;
      }
      if (!Object.prototype.hasOwnProperty.call(query, 'limit')) {
        parameters.limit = 30;
      } else {
        parameters.limit = query.limit;
      }
    }
    this.setParameters(parameters);
    return this.load();
  }

  search(keyword) {
    this.setParameter('q', keyword);
    return this.load();
  }

  delete(itemsIds) {
    const ids = Array.isArray(itemsIds) ? itemsIds : [itemsIds];
    return this.submit('delete', `/${this.endpoint}`, { players_ids: ids });
  }
}

export default PlayersProxy;
